export const environment = {
  appName: 'Handyhand',
  appUrl: 'https://dk.handyhand.dev',
  country: 'Denmark',
  platformUrl: 'https://dk.handyhand.dev/platform',
  production: true,
  env: 'development',
  supportEmail: 'support@handyhand.dk',
  supportPhone: '+45 93833441',
  apiUrl: 'https://api.handyhand.dev/api',
  apiV2Url: 'https://api-v2.handyhand.dev',
  vectorServiceUrl: 'https://vector.handyhand.dk/api', // There's no vector dev environment, using production
  dashboardBaseRef: 'https://api-dashboard.handyhand.dk/',
  apiPrefix: '',
  resizeUrl: 'https://d1w6ef92qmwkur.cloudfront.net',
  cloudFrontImgUrl: 'https://d10a6kin4dgxel.cloudfront.net',
  domain: 'https://dk.handyhand.dev',
  googleTagId: 'GTM-',
  posthog: {
    key: 'phc_1Yo4RANBQEmy4uBoYfBJ5rf5Km2RrVKwfs6gBR4SLsP',
    host: 'https://i.handyhand.dk',
  },
  social: {
    fb: 'https://da-dk.facebook.com/ahandyhand',
    instagram: 'https://www.instagram.com/handyhand.dk/',
    linkedin: 'https://dk.linkedin.com/company/handy-hand',
  },
};
